// utils.js
export const stripFontSizeStyles = (htmlContent) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, 'text/html');
    const elements = doc.body.querySelectorAll('*');
  
    elements.forEach(element => {
      element.style.fontSize = ''; // Remove inline font-size styles
    });
  
    return doc.body.innerHTML;
  };

  export function getRemarkBackground(index, total) {
  // index: 0 is oldest, total-1 is newest
  // We'll interpolate between two colors
  const oldestColor = '#f6fbff';
  //'#d0dae3'; // darker shade
  const newestColor = '#d0dae3';
  //'#f6fbff'; // lightest shade

  // Linear interpolation
  const ratio = index / (total - 1 || 1); // avoid division by zero
  // Simple interpolation between two hex colors
  function interpolateColor(a, b, t) {
    const ah = parseInt(a.replace('#', ''), 16);
    const bh = parseInt(b.replace('#', ''), 16);
    const ar = (ah >> 16) & 0xff, ag = (ah >> 8) & 0xff, ab = ah & 0xff;
    const br = (bh >> 16) & 0xff, bg = (bh >> 8) & 0xff, bb = bh & 0xff;
    const rr = Math.round(ar + (br - ar) * t);
    const rg = Math.round(ag + (bg - ag) * t);
    const rb = Math.round(ab + (bb - ab) * t);
    return `rgb(${rr},${rg},${rb})`;
  }
  return interpolateColor(oldestColor, newestColor, ratio);
};